import { render, staticRenderFns } from "./LevelUpAtProfa_2021_03_04.vue?vue&type=template&id=982c9954&scoped=true&"
import script from "./LevelUpAtProfa_2021_03_04.vue?vue&type=script&lang=js&"
export * from "./LevelUpAtProfa_2021_03_04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982c9954",
  null
  
)

export default component.exports